import { TableDefine } from '@/libs/tableHelper/type'
import { GenealogyApplyByEntrust } from '@/api/genealogy/GenealogyApplyByEntrust'
import { User } from '@/api/user/User'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<GenealogyApplyByEntrust> {
  const tableCols = [
    {
      title: '姓名',
      key: 'name'
    },
    {
      title: '手机号',
      key: 'phone'
    },
    {
      title: '地址',
      key: 'address'
    },
    {
      title: '状态',
      key: 'isAgree',
      type: {
        module: 'enum',
        enum: 'genealogy/agree'
      }
    },
    {
      title: '申请时间',
      type: {
        module: 'time',
        format: 'yyyy-MM-DD HH:mm:ss'
      },
      key: 'createTime'
    }
  ]

  const actions: any = [{
    name: 'agree',
    title: '通过申请',
    show: (item:any) => {
      return item.isAgree !== 1
    },
    modal: {
      message: '确定要通过该申请吗？'
    },
    onClick: (dataItem: User) => {
      view.agreeHandle(dataItem)
    }
  }]

  return {
    tableCols,
    actions
  }
}
